import styled from "styled-components";

export const Heading = styled.div`
  font-family: "latobold";
  font-size: 22px;
  line-height: 26px;
  margin-bottom: 10px;

  &.text-center {
    text-align: center;
  }
`;

export const SubHeading = styled.div`
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 20px;
  &.text-center {
    text-align: center;
  }
`;
